import { useEffect, useState } from "react";

const KEY = "showLabOrderedBy";
const EVENT_NAME = "showLabOrderedByChanged";

const useShowLabOrderedBy = (): {
  showLabOrderedBy: boolean;
  setShowLabOrderedBy: (value: boolean) => void;
} => {
  const [showLabOrderedBy, setShowLabOrderedBy] = useState<boolean>(() => {
    const stored = localStorage.getItem(KEY);
    return stored === null ? true : stored === "true";
  });

  // use effects
  useEffect(() => {
    localStorage.setItem(KEY, String(showLabOrderedBy));
    window.dispatchEvent(new Event(EVENT_NAME));
  }, [showLabOrderedBy]);

  useEffect(() => {
    const sync = () => {
      setShowLabOrderedBy(localStorage.getItem(KEY) === "true");
    };

    const handleStorage = (e: StorageEvent) => {
      if (e.key === KEY) {
        sync();
      }
    };

    window.addEventListener(EVENT_NAME, sync);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return { showLabOrderedBy, setShowLabOrderedBy };
};

export default useShowLabOrderedBy;
